import * as types from 'store/projectList/projectListTypes'

const initialState = {
  byClientId: {},
  q: '',
  sortDir: 'desc',
  sortBy: 'modifiedDate',
  status: -1,
  creatorId: -1,
  isLoading: false,
  projectsList: []
}

const projectReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ALL_PROJECTS_SUCCEEDED:
      console.log("inside fetch succeeded ",action)
      return {
        ...state,
        byClientId: {
          [action.payload.data.clientId]: action.payload.data.data,
        },
      }
    case types.FETCH_PROJECTS_LIST_REQUESTED:
      return {
        ...state,
        isLoading: true
      }
    case types.FETCH_PROJECTS_LIST_SUCCEEDED:
      console.log("inside fetch projects list succeeded ", action)
      return {
        ...state,
        projectsList: action.payload.data.data,
        isLoading: false
      }
    case types.UPDATE_FILTERS:
      console.log("inside update filters ", action)
      return {
        ...state,
        sortDir: action.payload.sortDir? action.payload.sortDir : state.sortDir,
        sortBy: action.payload.sortBy? action.payload.sortBy: state.sortBy,
        status: action.payload.status? action.payload.status: state.status,
        creatorId: action.payload.creatorId? action.payload.creatorId: state.creatorId,
        q: action.payload.q !== undefined? action.payload.q: state.q
      }
    case types.UPDATE_IS_LOADING:
      return {
        ...state, 
        isLoading: action.payload
      }
    default:
      return state
  }
}

export default projectReducer
